export default "__VITE_ASSET__BaIyZNwg__"